import { HubSpotSubmissionData } from '@workspace/interfaces';
import type { ContactFormData } from '@workspace/interfaces/contact-form.types';

export function getHubSpotCookie(): string {
  if (typeof document === 'undefined') return '';

  const cookieName = 'hubspotutk';
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }

  return '';
}

export function createHubSpotSubmissionData(formData: ContactFormData): HubSpotSubmissionData {
  const hutk = getHubSpotCookie();
  const submissionData: HubSpotSubmissionData = {
    fields: [
      { name: 'firstname', value: formData.firstname },
      { name: 'lastname', value: formData.lastname },
      { name: 'email', value: formData.email },
      { name: 'phone', value: formData.phone },
      { name: 'company', value: formData.company || '' },
      { name: 'state', value: formData.state },
      { name: 'area_of_work', value: formData.area_of_work },
      {
        name: 'where_did_you_hear_about_porta_',
        value: formData.where_did_you_hear_about_porta_ || '',
      },
      { name: 'enquiry_type___dropdown', value: formData.enquiry_type___dropdown },
      { name: 'message', value: formData.message },
      { name: 'opt_in_confirmation', value: formData.newsletter.toString() },
    ],
  };

  // Only include context if we have a valid hutk
  if (hutk) {
    submissionData.context = {
      hutk,
      pageUri: window.location.href,
      pageName: document.title,
    };
  }

  return submissionData;
}

export function createNewsletterSubmissionData(fields: { name: string; value?: string }[], includeContext = false) {
  const submission: any = {
    fields,
    submittedAt: Date.now(),
  };

  if (includeContext) {
    const hutk = getHubSpotCookie();
    if (hutk) {
      submission.context = {
        hutk,
        pageUri: typeof window !== 'undefined' ? window.location.href : '',
        pageName: typeof document !== 'undefined' ? document.title : '',
      };
    }
  }

  return submission;
}
